import { auth, FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import axios from 'axios'
import { INVITE_STAFF_ENDPOINT } from 'constants/urls'
import { push } from 'connected-react-router'
import { setEmailErrorAction } from 'reducks/error/actions'

const inviteStaff = (email: string, role: number, storeRefs: FirebaseDocRefType[], is_resend: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    // トークンを再取得する
    const token = await auth.currentUser?.getIdToken()
    if (typeof !token === 'undefined') {
      console.error('認証トークンの取得に失敗しました。')
      return
    }
    const store_ids = storeRefs.map((storeRef) => storeRef.id)
    try {
      await axios.post(
        INVITE_STAFF_ENDPOINT,
        { email, role, store_ids, is_resend },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      dispatch(hideLoadingAction())
      dispatch(push('/account/invite_member/complete'))
    } catch (e) {
      dispatch(hideLoadingAction())
      if (axios.isAxiosError(e)) {
        if (e.response?.data.status === 'warning') {
          dispatch(setEmailErrorAction(e.response.data.message))
        } else {
          console.error(e.response)
        }
      } else {
        console.error(e)
      }
    }
  }
}

export default inviteStaff
